import React from 'react';
type CompanyHeroProps = {
  eyebrow: string;
  headline: string;
  subheadline: string;
  image?: {
    src: string;
    alt: string;
  };
};
export function CompanyHero({
  eyebrow,
  headline,
  subheadline,
  image
}: CompanyHeroProps) {
  return <section className="hero-surface w-full" aria-labelledby="company-hero-heading" data-id="element-295" data-mp="1pz6mutp4e5di">
      <div className={`mx-auto max-w-shell px-6 pt-16 lg:pt-24 ${image ? 'pb-0' : 'pb-16 lg:pb-24'}`} data-id="element-296" data-mp="1u08n9durwnh2">
        <div className="max-w-[820px]" data-id="element-297" data-mp="2hq30vxmx2g2d">
          <p className="text-[14px] font-semibold text-brand" data-id="element-298" data-mp="2hr4di6jkzam7">{eyebrow}</p>
          <h1 id="company-hero-heading" className="display mt-4 text-[38px] font-semibold text-ink sm:text-[50px] lg:text-[60px]" data-id="element-299" data-mp="2mn36k7futgsy">
            {headline}
          </h1>
          <p className="mt-6 max-w-[600px] text-[18px] leading-[1.5] text-ink-muted" data-id="element-300" data-mp="2cw8lh6ecgn93">{subheadline}</p>
        </div>
        {image && <img src={image.src} alt={image.alt} className="mt-12 h-[260px] w-full rounded-t-[14px] object-cover sm:h-[380px] lg:mt-16 lg:h-[500px]" data-id="element-301" data-mp="35e44cs58n6ax" />}
      </div>
    </section>;
}